<div class="login-content">
  <hyperkit-typography variant="display" color="primary" align="center"
    >Sign In</hyperkit-typography
  >
  <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
    <div class="form-group">
      <hyperkit-input
        class="hyperkit-component"
        type="email"
        id="email"
        label="Email"
        placeholder="Email"
        formControlName="username"
      ></hyperkit-input>
    </div>

    <div class="form-group">
      <div class="password-group">
        <hyperkit-input
          class="hyperkit-component"
          type="password"
          id="password"
          label="Password"
          placeholder="Password"
          formControlName="password"
        ></hyperkit-input>
        <hyperkit-error [error]="error"></hyperkit-error>
        <hyperkit-link
          class="forgot-password hyperkit-component"
          variant="label1"
          color="primary"
          align="right"
          text="Forgot Password?"
          (click)="onForgotPassword()"
        ></hyperkit-link>
      </div>
    </div>
    <div class="button-wrapper">
      <hyperkit-button
        type="submit"
        class="sign-in-button"
        size="medium"
        [disabled]="!loginForm.valid"
        [fullWidth]="true"
        color="tertiary"
        text="Sign In"
      ></hyperkit-button>
      <div class="signup-prompt">
        <hyperkit-typography variant="body1" color="secondary"
          >Don't have an account?
        </hyperkit-typography>
        <hyperkit-button
          routerLink="/signup"
          variant="ghost"
          color="primary"
          text="Sign Up"
        ></hyperkit-button>
      </div>
    </div>
  </form>
  <div class="terms-text">
    <hyperkit-typography variant="body2" color="secondary">
      By logging in to Intel 471's website, you acknowledge and agree that your
      use of Intel 471's website and service is subject to your organization's
      agreement with Intel 471 and
      <a href="/terms">Terms and Conditions</a>. If your organization's use of
      Intel 471's website is subject to an evaluation subscription, the terms
      applicable to your use can be found at
      <a href="/eval-agreement">Evaluation Agreement</a>. If your organization's
      use of Intel 471's website is subject to a community subscription, the
      terms applicable to your use can be found at
      <a href="/community-terms">Community Terms of Service</a>.
    </hyperkit-typography>
  </div>
</div>
